export const cmIntegrationCSS = `
prm-topbar

{ display: none }
 

primo-explore

{ font-size: 0.9em; font-family: "Helvetica Neue", Helvetica, Arial, sans-serif }
 

.section-title-header, .sidebar-header

{ font-size: 1rem !important; }
 

/* 
prm-static md-content md-card, prm-account md-content md-card,
md-content, md-content.md-primoExplore-theme,
.full-view-inner-container, .list-item-wrapper

{ background-color: #fff !important; }
*/
.list-item-wrapper:hover .list-item-primary-content:before

{ background-color: #f3f3f3 !important; }
 

._sm .prm-hue2.sidebar, .sm prm-facet.prm-hue2, ._sm prm-full-view-cont .recommendations-title:after,
._sm prm-full-view-cont .recommendations-title prm-icon, ._sm prm-full-view-cont .recommendations-wrapper,
._xs .prm-hue2.sidebar, .xs prm-facet.prm-hue2, ._xs prm-full-view-cont .recommendations-title:after,
._xs prm-full-view-cont .recommendations-title prm-icon, ._xs prm-full-view-cont .recommendations-wrapper,
.available-facets .section-content .md-chips .md-chip .prm-hue2.md-button:before,
.full-view-inner-container, .line-clamp-1:after, .line-clamp-2:after,
.line-clamp-3:after, .line-clamp-4:after, .line-clamp-5:after,
.list-item-wrapper, .multiselect-submit .prm-hue2.multiselect-submit-inner,
.prm-background.prm-hue2, .prm-full-view-dialog,
.prm-horizontal-content .horizontal-content-item md-card>.md-button,
.prm-hue2.prm-view-overlay-inner, .recommendations-title:after,
.recommendations-title prm-icon, .tiles-grid-tile, .tiles-grid-tile .tile-content prm-spinner.overlay-cover:after,
.tiles-grid-tile md-list prm-spinner.overlay-cover:after, body.prm-hue2,
html.prm-hue2, md-card.default-card, md-card .prm-hue2.card-content-block,
md-dialog md-toolbar.prm-hue2:not(.md-menu-toolbar), md-grid-tile,
md-grid-tile .tile-content prm-spinner.overlay-cover:after,
md-grid-tile md-list prm-spinner.overlay-cover:after, md-list.prm-list.prm-linkable-list-items md-list-item ._md-list-item-inner,
md-virtual-repeat-container#prm-simple-search .md-autocomplete-suggestions md-divider.prm-hue2,
prm-atoz-search-bar .advanced-search-output md-card,
prm-atoz-search-bar .advanced-search-tabs, prm-atoz-search-bar .simple-search-wrapper .prm-hue2.search-options:after,
prm-atoz-search-bar .simple-search-wrapper .search-options md-divider.prm-hue2,
prm-browse-search-bar .advanced-search-output md-card,
prm-browse-search-bar .advanced-search-tabs, prm-browse-search-bar .simple-search-wrapper .prm-hue2.search-options:after,
prm-browse-search-bar .simple-search-wrapper .search-options md-divider.prm-hue2,
prm-browse-search md-list.prm-list.prm-linkable-list-items md-list-item ._md-list-item-inner,
prm-databases-categorize .prm-hue2.sticking-wrapper,
prm-featured-result-item md-card, prm-featured-result-item md-card md-card-title,
prm-featured-results .horizontal-content-container .prm-hue2.horizontal-content-control,
prm-full-view-cont .prm-hue2.recommendations-title:after,
prm-full-view-cont .recommendations-title prm-icon.prm-hue2,
prm-full-view-cont prm-recomendation-item .media-on-hover .prm-hue2.pin-button,
prm-gallery-collection .collection-folder, prm-gallery-collection .collection-folder .item-meta,
prm-gallery-collection .collection-folder h3 span, prm-gallery-item .collection-element,
prm-gallery-item .collection-element .item-title, prm-gallery-item .collection-element .resource-type,
prm-newspapers-search-bar .advanced-search-output md-card,
prm-newspapers-search-bar .advanced-search-tabs,
prm-newspapers-search-bar .simple-search-wrapper .prm-hue2.search-options:after,
prm-newspapers-search-bar .simple-search-wrapper .search-options md-divider.prm-hue2,
prm-recomendation-item .media-on-hover .pin-button,
prm-recomendation-item .media-on-hover .pin-button:hover,
prm-resource-recommender md-card, prm-search-bar .advanced-search-output md-card,
prm-search-bar .advanced-search-tabs, prm-search-bar .simple-search-wrapper .prm-hue2.search-options:after,
prm-search-bar .simple-search-wrapper .search-options md-divider.prm-hue2,
prm-search-result-list .results-footer, prm-search-result-list .results-header,
prm-search .prm-hue2.ui-blocker, prm-tags-results-list md-list.prm-list.prm-linkable-list-items md-list-item ._md-list-item-inner,
prm-tags-search-bar .advanced-search-output md-card,
prm-tags-search-bar .advanced-search-tabs, prm-tags-search-bar .simple-search-wrapper .prm-hue2.search-options:after,
prm-tags-search-bar .simple-search-wrapper .search-options md-divider.prm-hue2


{ background-color: #fff !important; }
 

._sm .sidebar, .sm prm-facet, .xs .sidebar, ._xs prm-facet,
.available-facets .section-content .md-chips .md-chip .md-button:before,
.multiselect-submit .multiselect-submit-inner, .prm-background,
.prm-view-overlay-inner, body, html, md-card .card-content-block,
md-dialog md-toolbar:not(.md-menu-toolbar), md-virtual-repeat-container#prm-simple-search .md-autocomplete-suggestions md-divider,
prm-atoz-search-bar .simple-search-wrapper .search-options:after,
prm-atoz-search-bar .simple-search-wrapper .search-options md-divider,
prm-browse-search-bar .simple-search-wrapper .search-options:after,
prm-browse-search-bar .simple-search-wrapper .search-options md-divider,
prm-databases-categorize .sticking-wrapper, prm-featured-results .horizontal-content-container .horizontal-content-control,
prm-full-view-cont .recommendations-title:after, prm-full-view-cont .recommendations-title prm-icon,
prm-full-view-cont prm-recomendation-item .media-on-hover .pin-button,
prm-newspapers-search-bar .simple-search-wrapper .search-options:after,
prm-newspapers-search-bar .simple-search-wrapper .search-options md-divider,
prm-search-bar .simple-search-wrapper .search-options:after,
prm-search-bar .simple-search-wrapper .search-options md-divider,
prm-search .ui-blocker, prm-tags-search-bar .simple-search-wrapper .search-options:after,
prm-tags-search-bar .simple-search-wrapper .search-options md-divider

{ background-color: #fff !important; border-color: transparent !important; }
 

prm-spinner

{ transition: none !important; }
 

prm-explore-main .header>prm-spinner

{ top: 100px !important; }
 

prm-explore-main .header>prm-spinner .loader .diamond:nth-child(1)

{ left: 100px !important; top: 45px !important; }
 

.pinDummy

{ display: none !important; }
 

.loader .diamond

{ display: none !important; }
 

.loader .diamond:nth-child(1)

{ animation: none !important; -webkit-animation: none !important; transform: none !important; -webkit-transform: none !important; display: block !important; background-color: transparent !important; }
 

.loader .diamond:nth-child(1):after

{ display: block; position: absolute; content: ''; top: 50%; left: 50%; margin: -1.5em 0 0 -1.5em; width: 3em; height: 3em; -webkit-animation: animation-5bz3sx 0.6s linear; animation: animation-5bz3sx 0.6s linear; -webkit-animation-iteration-count: infinite; animation-iteration-count: infinite; border-radius: 500rem; border-color: #767676 rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1); border-style: solid; border-width: 0.2em; box-shadow: 0px 0px 0px 1px transparent; visibility: visible; z-index: 101; }
 

@
keyframes animation-5bz3sx {from

{ -webkit-transform:rotate(0deg); -ms-transform: rotate(0deg); transform: rotate(0deg); }
 

to

{ -webkit-transform: rotate(360deg); -ms-transform: rotate(360deg); transform: rotate(360deg); }
 

}
@
-webkit-keyframes animation-5bz3sx {from

{ -webkit-transform:rotate(0deg); -ms-transform: rotate(0deg); transform: rotate(0deg); }
 

to

{ -webkit-transform: rotate(360deg); -ms-transform: rotate(360deg); transform: rotate(360deg); }
 

}

 

#voiceSearchButton

{ display: none; }
'


// WEBPACK FOOTER //
// ./src/main/webapp/styles/cm-integration-css.ts